import script from "./BrowsePicksSearchPillGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowsePicksSearchPillGroup.vue?vue&type=script&setup=true&lang=js"

import "./BrowsePicksSearchPillGroup.vue?vue&type=style&index=0&id=388a88a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388a88a5"]])

export default __exports__